// IIFE 進入點（→ widget.iife.js）。註冊元件（經 ./index）並自動掛載頁面上所有嵌入。
// 這是唯一會掃宿主頁面 DOM 的模組 —— package 進入點 (./index) 刻意不掃，
// 因此 admin 預覽 import 此套件時永遠不會誤觸自動掛載。(spec §5.1)
// 模組圖保證 ./index（註冊元件）在 autoMount 之前求值完成，import 的文字順序不影響 define 時機。
import { autoMount } from './mount'
import { installSdk } from './sdk'
import './index'

// 先裝上命令式 window.Pulse（並 drain 頁面在載入前排隊的 cmd），再於 DOM ready 自動掛載
// declarative 嵌入。兩條路徑共用同一個已註冊的 <pulse-survey>。
installSdk()

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', () => autoMount(), { once: true })
else
  autoMount()
